module.exports = __webpack_public_path__ + "media/images/pc/stores/sola/how-to-enjoy-sola-05-9f3be057e9e9d29dad463edb24f3c586.jpg";